<template>
  <div class="radioGroup__style">
    <div v-if="multiple">
      <a-radio :value="0" :default-checked="true" disabled class="radio__style" >
        <span>非公开</span><br/>
        <span class="radio__text--span">必须将项目访问权明确授予每个客户</span>
      </a-radio>
      <a-radio-group :defaultValue="2" class="radio__group" @change="multipleOnChange">
        <a-radio :value="1" class="radio__style">
          <span>内部的</span><br/>
          <span class="radio__text--span">任何登录的用户都可以访问该项目</span>
        </a-radio>
        <a-radio :value="2" class="radio__style">
          <span>公开</span><br/>
          <span class="radio__text--span">无需任何身份验证即可访问该项目</span>
        </a-radio>
      </a-radio-group>
    </div>
    <div v-else>
      <a-radio-group :defaultValue="checked" class="radio__group" @change="singleOnChange">
        <a-radio :value="0" class="radio__style" >
          <span>非公开</span><br/>
          <span class="radio__text--span">必须将项目访问权明确授予每个客户</span>
        </a-radio>
        <a-radio :value="1" class="radio__style">
          <span>内部的</span><br/>
          <span class="radio__text--span">任何登录的用户都可以访问该项目</span>
        </a-radio>
        <a-radio :value="2" class="radio__style">
          <span>公开</span><br/>
          <span class="radio__text--span">无需任何身份验证即可访问该项目</span>
        </a-radio>
      </a-radio-group>
    </div>
    <a-button type="primary" class="radio__btn" @click="buyProject">升级权限</a-button>
  </div>
  
</template>
<script>
export default {
  name:'PermissionsChoose',
  data () {
    return {
      valOptions:2 // 选中的值
    }
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    checked: {
      type: Number,
      default: 0
    }
  },
  methods:{
    multipleOnChange(e){
      this.valOptions = e.target.value
      this.$emit('selectRido',[0,this.valOptions])
    },
    singleOnChange(e) {
      this.valOptions = e.target.value
      this.$emit('selectRido',this.valOptions)
    },
    buyProject(){
      this.$emit('buy')
      this.$router.push({
        path:'/buy/index'
      })
    }
  }
}
</script>
<style scoped>
@import url('./index.css');
</style>